var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 24 24","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M24 6H0V2h24v4zm0 4H0v4h24v-4zm0 8H0v4h24v-4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }